export default __webpack_public_path__ + "static/media/blueCheck.bd99b64a.svg";